<template>
  <v-text-field
    :id="id"
    v-model="getValue"
    v-mask="setMask"
    :outlined="outlined"
    :color="color"
    v-bind="$attrs"
    @blur="$emit('blur', $event)"
    @keypress.native.enter="setValue($event)"
  />
</template>

<script>
import VuetifyOverwriteMixin from './VuetifyOverwriteMixin';

export default {
  name: 'InputCpfCnpj',
  mixins: [VuetifyOverwriteMixin],
  computed: {
    isCpf() {
      return this.value && this.value
        .toString().replace(/[^0-9]+/g, '').length === 11;
    },
    setMask() {
      return this.isCpf ? '###.###.###-##' : '##.###.###/####.##';
    },
  },
};
</script>
